import {
    Text6,
    Text3,
    Spinner,
    EmptyState,
    Row,
    RowList,
    skinVars,
    IconMobileDeviceRegular,
} from '@telefonica/mistica';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { dateToLongMonth, getFormatDate } from '../../../utils/dataTransformation/dateConversions';
import { conversionKBtoMbOrGB, formatPrices } from '../../../utils/dataTransformation/unitsConversion';
import './index.scss';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSearchParams } from 'react-router-dom';
import { getAllConsDetail } from '../../../services/ConsumptionService';

const DetailConsumptionDataList: React.FC = () => {
    const [isLoading, setLoading] = useState(true);
    type ConsDetail = {
        dateTime: string;
        cost: number;
        usage: number;
    };
    const [listData, setListData] = useState<ConsDetail[]>([]);
    const [searchParams] = useSearchParams();
    const productPsId: any = searchParams.get('productPsId');
    const [page, setPage] = useState(1);
    const [moreElements, setMoreElements] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        getMoreDetails();
    }, []);

    const getMoreDetails = async () => {
        if (isFetching) return;
        setIsFetching(true);
        try {
            const paramsIncluded = {
                productPsId: productPsId,
                consumptionType: 'DATA' as const,
                mode: 'included' as const,
                page: page,
                size: 31,
            };
            const paramsExtra = {
                productPsId: productPsId,
                consumptionType: 'DATA' as const,
                mode: 'extra' as const,
                page: page,
                size: 31,
            };
            const [resIncluded, resExtra] = await Promise.all([
                getAllConsDetail(paramsIncluded),
                getAllConsDetail(paramsExtra),
            ]);
            const dataIncluded = resIncluded.data.details || [];
            const dataExtra = resExtra.data.details || [];
            const merged = [...listData, ...dataIncluded, ...dataExtra].sort((a, b) => {
                return new Date(b.dateTime).getTime() - new Date(a.dateTime).getTime();
            });
            setListData(merged as ConsDetail[]);
            setPage(page + 1);
            setMoreElements(resIncluded.data.moreElements || resExtra.data.moreElements);
            setLoading(false);
        } catch (err) {
            setHasError(true);
            setLoading(false);
        } finally {
            setIsFetching(false);
        }
    };

    if (isLoading) {
        return (
            <div className='extraExpenseDetails-page'>
                <div className='extraExpenseDetails-page__loading'>
                    <div className='extraExpenseDetails-page__loading__spinner'>
                        <Spinner size={'32px'} color={skinVars.colors.navigationBarBackground}></Spinner>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className='DetailConsumptionData'>
            {!isLoading && !hasError && listData.length > 0 ? (
                <InfiniteScroll
                    dataLength={listData.length}
                    next={getMoreDetails}
                    hasMore={moreElements}
                    loader={moreElements ? <h4></h4> : null}
                >
                    <RowList>
                        {listData.map((item: any, index: number) => {
                            let pivot = 0;
                            const longMonth = dateToLongMonth(item.dateTime.substring(5, 7));
                            if (index != 0) {
                                const value: any = listData[index - 1];
                                pivot = new Date(value.dateTime).getUTCDate();
                            }
                            if (index == 0) {
                                return (
                                    <div key={index}>
                                        <div className='DetailConsumptionData__item-text'>
                                            <Text3 medium color={skinVars.colors.textSecondary}>
                                                {getFormatDate(item.dateTime, '00 MMMM')}
                                            </Text3>
                                        </div>
                                        <div>
                                            <Row
                                                title=''
                                                right={
                                                    <div>
                                                        <Text6
                                                            color={
                                                                item.cost > 0
                                                                    ? skinVars.colors.errorHigh
                                                                    : skinVars.colors.textPrimary
                                                            }
                                                        >
                                                            {formatPrices(item.cost, 'spent')}
                                                        </Text6>
                                                    </div>
                                                }
                                                headline={
                                                    <div className='DetailConsumptionData__row-headline'>
                                                        <div className='DetailConsumptionData__row-headline-consumption'>
                                                            <div>
                                                                <Text3 regular>
                                                                    {conversionKBtoMbOrGB(item.usage)}
                                                                </Text3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            ></Row>
                                        </div>
                                    </div>
                                );
                            } else if (pivot != item.dateTime.substring(8, 10)) {
                                return (
                                    <div key={index}>
                                        <div className='DetailConsumptionData__item-text'>
                                            <Text3 medium color={skinVars.colors.textSecondary}>
                                                {getFormatDate(item.dateTime, '00 MMMM')}
                                            </Text3>
                                        </div>
                                        <Row
                                            title=''
                                            right={
                                                <div>
                                                    <Text6
                                                        color={
                                                            item.cost > 0
                                                                ? skinVars.colors.errorHigh
                                                                : skinVars.colors.textPrimary
                                                        }
                                                    >
                                                        {formatPrices(item.cost, 'spent')}
                                                    </Text6>
                                                </div>
                                            }
                                            headline={
                                                <div className='DetailConsumptionData__row-headline'>
                                                    <div className='DetailConsumptionData__row-headline-consumption'>
                                                        <div>
                                                            <Text3 regular>{conversionKBtoMbOrGB(item.usage)}</Text3>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        ></Row>
                                    </div>
                                );
                            } else {
                                return (
                                    <div key={index}>
                                        <Row
                                            title=''
                                            right={
                                                <div>
                                                    <Text6
                                                        color={
                                                            item.cost > 0
                                                                ? skinVars.colors.errorHigh
                                                                : skinVars.colors.textPrimary
                                                        }
                                                    >
                                                        {formatPrices(item.cost, 'spent')}
                                                    </Text6>
                                                </div>
                                            }
                                            headline={
                                                <div className='DetailConsumptionData__row-headline'>
                                                    <div className='DetailConsumptionData__row-headline-consumption'>
                                                        <div>
                                                            <Text3 regular>{conversionKBtoMbOrGB(item.usage)}</Text3>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        ></Row>
                                    </div>
                                );
                            }
                        })}
                    </RowList>
                </InfiniteScroll>
            ) : (
                !hasError && (
                    <div className='DetailConsumptionData__emptyState'>
                        <EmptyState
                            asset={<IconMobileDeviceRegular color={skinVars.colors.brand} size={64} />}
                            title={t('titleDataDetails')}
                            description={t('descriptionDataDetails')}
                        ></EmptyState>
                    </div>
                )
            )}
        </div>
    );
};

export default DetailConsumptionDataList;
